import { render } from "./LesVideotheques.vue?vue&type=template&id=c8c676a8&scoped=true&ts=true"
import script from "./LesVideotheques.vue?vue&type=script&lang=ts"
export * from "./LesVideotheques.vue?vue&type=script&lang=ts"

import "./LesVideotheques.vue?vue&type=style&index=0&id=c8c676a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c676a8"]])

export default __exports__